<template>
	<div class="sortable-list-item" :style="{ height }">
		<div class="content" ref="content" :style="{ top }">
			<div class="component">
				<slot />
			</div>
			<div class="actions">
				<Action title="Move down" :disabled="last" @click="moveDown"><IconDown /></Action>
				<Action title="Move up" :disabled="first" @click="moveUp"><IconUp /></Action>
				<div class="spacer"></div>
				<Action class="delete" title="Remove item" @click="remove"><IconClose /></Action>
			</div>
		</div>
	</div>
</template>

<script>
import IconClose from 'mdi-vue/Close'
import IconUp from 'mdi-vue/ArrowUp'
import IconDown from 'mdi-vue/ArrowDown'
import Action from '@/components/Action'

export default {
	name: 'SortableListItem',
	props: {
		first: Boolean,
		last: Boolean,
	},
	data() {
		return {
			offsetHeight: 0,
			offsetTop: 0,
		}
	},
	computed: {
		height() {
			return this.offsetHeight + 'px'
		},
		top() {
			return this.offsetTop + 'px'
		},
	},
	methods: {
		measure() {
			this.offsetHeight = this.$refs.content.offsetHeight
			this.offsetTop = this.$el.offsetTop
		},
		remove() {
			this.$emit('remove')
		},
		moveUp() {
			this.$emit('reorder', { dir: -1 })
		},
		moveDown() {
			this.$emit('reorder', { dir: 1 })
		},
	},
	updated() {
		this.measure()
	},
	mounted() {
		this.measure()
		window.addEventListener('resize', this.measure)
	},
	beforeDestroy() {
		window.removeEventListener('resize', this.measure)
	},
	components: {
		IconClose,
		IconUp,
		IconDown,
		Action,
	},
}
</script>

<style lang="scss" scoped>
@import '~scss/vars';
@import '~scss/layout';
@import '~scss/components';
@import '~scss/mq';

$pad: 0.5rem;

.sortable-list-item {
	margin: 1rem 0;

	.content {
		@extend %flex-col-center;
		align-items: stretch;
		background-color: $grey-95;
		width: 100%;
		position: absolute;
		transition: top 0.2s;
	}

	.component {
		flex-grow: 1;
	}

	.actions {
		display: flex;
		padding: 0 $pad $pad;

		.delete {
			color: $col-error;
		}

		.spacer {
			flex-grow: 1;
		}
	}

	@include mq(md) {
		.content {
			flex-direction: row;
			align-items: center;
		}

		.actions {
			padding-top: $pad;
			padding-left: 0;
		}

		.spacer {
			display: none;
		}
	}
}

.action {
	@include circle-button(1.5rem, $white, $grey-90);
}
</style>
